if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const myDiv = document.querySelector('ld-customizer');
        const myCus = document.querySelector('ld-information-manager');

        if (myDiv) {
          if (myDiv.classList.contains('hidden')) {

          } else {
            const colInput = document.querySelector('[name="properties[Choose Your Collection]"]');
            const colValue = colInput.value;
            if (colValue === "" && myCus.classList.contains('hidden')) {
              document.querySelector('.pf-error').innerHTML = "Please select a collection";
              return;
            } else {
              document.querySelector('.pf-error').innerHTML = "";
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.multi = this.form.dataset.multi;
        this.popup = this.form.dataset.popup;
        this.ogp = this.form.dataset.og;

        const formData = new FormData(this.form);

        // Build main product item with all properties from the form
        const mainItem = {
          id: formData.get('id'),
          quantity: 1,
          properties: {}
        };

        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const cleanKey = key.replace('properties[', '').replace(']', '');
            mainItem.properties[cleanKey] = value;
          }
        }

        // Collect add-on items
        const addonItems = [];
        document.querySelectorAll('.addon-form input:checked').forEach((el) => {
          addonItems.push({
            id: el.dataset.variant,
            quantity: 1,
            properties: { 'For product': this.ogp }
          });
        });

        // Single request with main product, add-ons, and sections together
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [mainItem, ...addonItems],
            sections: this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [],
            sections_url: window.location.pathname
          })
        })
          .then((res) => {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then((data) => {
            if (data.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainItem.id,
                errors: data.errors || data.description,
                message: data.message,
              });
              this.handleErrorMessage(data.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              this.cart.renderContents(data);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainItem.id,
                cartData: data,
              });
            }
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            if (this.popup == 'yes') { document.querySelector("modal-opener.product-upsell button").click(); }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}